<template>
  <base-layout :do-skip-header="false" :doSkipPic="shouldSkipPic">
    <template #main>
      <h1 class='text-3xl md:text-4xl font-bold mt-8'>April Fools! We got you 😜</h1>

        <div class="mx-auto max-w-7xl px-6 lg:px-8 bg-gray-100 p-8 rounded-lg shadow-lg mt-12">
          
            <strong>No, we’re not giving away free tickets. And honestly, that’s for a reason.</strong>
            <br><br>
            The European Broker Meeting has never been about filling a room. It’s about bringing the right people together. Every company attending is a TBS member, which means they are <strong>verified and part of a trusted network</strong>. We don’t just open the doors to anyone. Because the value of this event comes from the people in the room. 
            <br><br>
            Every year, serious traders come to connect, build relationships, and close real deals. <strong>Millions in business are done during the event</strong>, and that only works when people are there for the right reasons, not for freebies, but for real opportunities.
            <br><br>
            If you’ve been before, you already know. If you haven’t, this is what you can expect: strong connections, reliable partners, and conversations that actually lead somewhere.
            <br><br>
            One thing is true, though: if you book your tickets before July, you’ll save hundreds of euros!
            <br><br>
            <div class="flex justify-center mt-8">
              <router-link to="/register" class="bg-red-600 text-white px-6 py-4 rounded-md inline-block text-center text-lg font-bold">Register now and save 100s!</router-link>
            </div>
        </div>


    </template>
  </base-layout>
</template>

<script>
import _ from "lodash";
import BaseLayout from "../components/BaseLayout.vue";

export default {
  name: "Register",
  components: {
    BaseLayout,
  },
  data() {
    return {
      mainSponsor: null, 
      sponsors: [],
      sponsorLimit: 25,
      showSponsorLimit: true,
      showFullFloorplan: true,
      shouldSkipPic: false,
    };
  },
  async created(){
    this.shouldSkipPic = false
  },
  methods: {
  }
};
</script>

<style>
.special-sponsor img {
  grid-column: span 2;
}
</style>